import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useState } from "react";
import "../index.css";
import { Button } from "./ui/button/button";
import { ButtonSize } from "./ui/button/button.type";
import { LocalStorageKeys } from "../constants";
import { trackAmplitudeEvent } from "@/utils/amplitude";

interface PrivacyPolicyProps {
  onClose: () => void;
  showAccept?: boolean;
}

function PrivacyPolicy({ onClose, showAccept = true }: PrivacyPolicyProps) {
  const [open, setOpen] = useState(true);

  const handleOpenChange = (isOpen: boolean) => {
    setOpen(isOpen);
    if (!isOpen) {
      onClose();
    }
  };

  const handlePrivacyPolicyAccepted = async () => {
    trackAmplitudeEvent("PRIVACY_POLICY_ACCEPTED");
    try {
      await localStorage.setItem(
        LocalStorageKeys.PRIVACY_POLICY_ACCEPTED,
        "true",
      );
      setOpen(false);
    } catch (error) {
      console.error("Error in saving policy state ", error);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange} modal={true}>
      {/* <DialogTrigger defaultChecked>
        <Button variant='outline'>Edit Profile</Button>
      </DialogTrigger> */}
      <DialogContent className="h-[90%] w-80 rounded-lg dark:bg-white">
        <DialogHeader>
          <DialogTitle className="font-satoshiBlack text-[14px] tracking-wide">
            GENERAL TERMS OF SERVICE
          </DialogTitle>
          <DialogDescription className="text-[14px] tracking-wide">
            Security and privacy policy for P2P.me.
          </DialogDescription>
        </DialogHeader>
        <div className="policy-content overflow-scroll">
          <div className="content">
            THE SERVICES (AS DEFINED HEREIN) WERE NOT DEVELOPED FOR, AND ARE NOT
            OFFERED TO PERSONS OR ENTITIES WHO RESIDE IN, ARE CITIZENS OF, ARE
            LOCATED IN, ARE INCORPORATED IN, OR HAVE A REGISTERED OFFICE OR
            PRINCIPAL PLACE OF BUSINESS IN ANY RESTRICTED JURISDICTION OR
            COUNTRY SUBJECT TO ANY SANCTIONS OR RESTRICTIONS PURSUANT TO ANY
            APPLICABLE LAW, INCLUDING THE CRIMEA REGION, CHINA, PAKISTAN,
            BANGLADESH, BHUTAN, NEPAL, MYANMAR, AFGANISTHAN CUBA, IRAN, NORTH
            KOREA, PANAMA, SYRIA, RUSSIA, OR ANY OTHER COUNTRY IN WHICH THE
            UNITED STATES, THE UNITED KINGDOM, THE EUROPEAN UNION, THE REPUBLIC
            OF PANAMA OR ANY OTHER JURISDICTION EMBARGOES GOODS OR IMPOSES
            SIMILAR SANCTIONS, OR ANY JURISDICTIONS IN WHICH THE TRANSACTING OF
            CRYPTOCURRENCIES IS PROHIBITED OR RESTRICTED IN ANY FORM OR MANNER
            (COLLECTIVELY, THE “RESTRICTED JURISDICTIONS” AND EACH A “RESTRICTED
            JURISDICTION”) OR ANY PERSON OWNED, CONTROLLED, LOCATED IN OR
            ORGANIZED UNDER THE LAWS OF ANY RESTRICTED JURISDICTION OR
            AFFILIATED WITH ANY SUCH PERSON, ANY PERSON LISTED ON ANY SANCTIONS
            LIST MAINTAINED BY THE UNITED STATES, THE UNITED KINGDOM, THE
            EUROPEAN UNION OR ANY OTHER JURISDICTION, OR A RESIDENT OF OR
            LOCATED IN ANY COUNTRY OR JURISDICTION THAT RESTRICTS ACCESS TO OR
            PROHIBITS USE OF DIGITAL ASSETS OR CRYPTO CURRENCIES (COLLECTIVELY,
            “RESTRICTED PERSONS”). THERE ARE NO EXCEPTIONS. IF YOU ARE A
            RESTRICTED PERSON, OR LOCATED IN A RESTRICTED JURISDICTION, THEN DO
            NOT USE OR ATTEMPT TO USE THE SERVICES. USE OF ANY TECHNOLOGY OR
            MECHANISM, SUCH AS A VIRTUAL PRIVATE NETWORK, TO CIRCUMVENT OR
            ATTEMPT TO CIRCUMVENT THE RESTRICTIONS SET FORTH HEREIN IS STRICTLY
            PROHIBITED.
          </div>
          <div className="content">
            BY USING THE SERVICES, YOU REPRESENT THAT (I) YOU ARE NOT A
            RESTRICTED PERSON; AND (II) YOU (INCLUDING, IF APPLICABLE, YOUR
            INDIVIDUAL OWNERS, REPRESENTATIVES, EMPLOYEES, OR ANY OTHER PERSON
            WITH ACCESS TO YOUR ACCOUNT) WILL NOT COORDINATE, CONDUCT OR CONTROL
            (INCLUDING BY, IN SUBSTANCE OR EFFECT, MAKING DECISIONS WITH RESPECT
            TO) YOUR USE OF THE SERVICES FROM WITHIN ANY RESTRICTED
            JURISDICTION.
          </div>
          <div className="content">
            YOU ACKNOWLEDGE, UNDERSTAND AND AGREE THAT YOU ARE NOT PERMITTED TO
            MODIFY, DISASSEMBLE, DECOMPILE, ADAPT, ALTER, TRANSLATE, REVERSE
            ENGINEER OR CREATE DERIVATIVE WORKS OF THE SERVICES TO MAKE THEM
            AVAILABLE TO ANY RESTRICTED PERSONS OR IN ANY RESTRICTED
            JURISDICTION.
          </div>
          <div className="content">
            These terms of use are entered into by and between you and Fair
            Fractal Corp. (“Company”, “we” or “us”).The following Terms and
            Conditions (“Terms”) govern your access to and use of P2P.me’s
            products and services, including our website, user interface and
            mobile wallet application (“P2P.me Wallet”), and any other related
            services or products (collectively referred to as the “Product”). By
            accessing or using any part of the Product, you agree to be bound by
            these Terms. If you do not agree, please discontinue your use of the
            Product immediately.
          </div>
          <div className="subHeading text-text-primary">1. Access</div>
          <div className="contentBold">
            By accessing or using our Product you represent and warrant that you
            are at least 18 years of age and able to form a legally binding
            contract with us. If you are under the age of 18 years of age, you
            must not use the Product.
          </div>
          <div className="content">
            You further represent and warrant that you are not subject to
            economic or trade sanctions administered or enforced by any
            governmental authority or otherwise designated on any lists of
            prohibited or restricted parties (including but not limited to the
            list maintained by the Office of Foreign Assets or Control (OFAC) of
            the U.S. Department of the Treasury and You are not located,
            incorporated, otherwise established in, a citizen of, or resident
            of, or have business operations in any country or region subject to
            a sanction regime, including sectoral sanctions imposed by the EU,
            the UN, UK, USA. e.g. the Democratic People’s Republic of North
            Korea).
          </div>
          <div className="content">
            Your access to and/or use of any Product is subject to these Terms
            herein and all applicable laws and regulations. By accessing,
            attempting to access and/or using our Product, you accept and agree
            to abide by these Terms. If you do not accept and agree to these
            Terms, please do not use our Product.
          </div>{" "}
          <div className="subHeading text-text-primary">2. Modifications</div>
          <div className="content">
            {" "}
            We reserve the right to modify these Terms, at our sole discretion
            from time to time. If we make any material modifications, we will
            notify you by updating the date at the top of the Terms, as
            indicated above. We reserve the rights to with or without any notice
            to modify, substitute, eliminate, or add to the Product; or review,
            modify, filter, disable, delete and remove any and all content and
            information from the Product.{" "}
          </div>
          <div className="subHeading text-text-primary">3. Our Products</div>
          <div className="flex gap-1">
            <div className="subHeadingSpan text-text-primary">3.1 </div>
            <div className="contentBold"> Interface:</div>
          </div>{" "}
          <div className="content">
            {" "}
            The Product provides web and mobile access to a decentralised
            protocol on the Base Blockchain, which is a Layer 2 solution built
            on the Ethereum Blockchain. This Protocol enables users to interact
            directly with one another in a peer-to-peer manner, facilitating the
            swapping of cryptocurrency and fiat.
          </div>
          <div className="content">
            {" "}
            The Product is separate from the Protocol and serves as one of
            several means to access it. The Protocol consists of three distinct
            versions, designated as v1, v2, and v3, each comprising open-source,
            self-executing smart contracts deployed across various public
            blockchains, including Polygon, Base, and Ethereum. We do not
            control or operate any version of the Protocol. The Protocol has
            been developed as a public good by an anonymous cohort of
            developers.
          </div>
          <div className="content">
            {" "}
            By engaging in the buying and selling of digital assets and fiat
            currencies and swapping between the two, you acknowledge that these
            transactions are not conducted with us. We do not operate any
            liquidity pools or control trade execution on the Protocol. All
            trades are executed by third parties, and liquidity pools are
            managed independently by such third parties, we only provide you an
            interface.
          </div>
          <div className="content">
            {" "}
            The Protocol is not the Product. We do not control the Protocol and
            as a result of which you acknowledge and willfully undertake the
            inherent risks associated with the use of the Product.
          </div>
          <div className="flex gap-1">
            <div className="subHeadingSpan text-text-primary">3.2 </div>
            <div className="contentBold">P2P.me Wallet:</div>
          </div>{" "}
          <div className="content">
            {" "}
            To access the Product, you must use a non-custodial wallet, the
            cryptographic private keys of which are retained solely by you. This
            means you maintain full control and ownership of your digital assets
            at all times. We do not have control over, nor do we have access to,
            the non-custodial wallets that you create on our platform. Please
            note that your use of the wallet will be governed by our Terms of
            Service and Third Web’s terms and privacy policy, which can be
            accessed at Terms and Privacy Policy. We integrate Third Web as a
            third-party wallet service provider for P2P.me Wallet.
          </div>
          <div className="content">
            {" "}
            You hold the private keys and are therefore solely responsible for
            the security, management and ownership of your wallet and associated
            funds. We cannot recover your wallet or assist in the retrieval of
            any lost or forgotten private keys. It is your sole responsibility
            to ensure that your wallet is secured against unauthorised access,
            and you should take all necessary precautions to protect your
            private keys.
          </div>
          <div className="content">
            {" "}
            By using a non-custodial wallet, you acknowledge and accept that we
            cannot facilitate transactions or provide support for wallet-related
            issues. We advise you to familiarise yourself with best practices
            for wallet security and to seek professional advice if needed.
          </div>
          <div className="contentBold">
            {" "}
            Your profile information and reputation points will be publicly
            visible. However, your fiat transaction history will not be visible
            to us and will only be visible to the user you are interacting with
            for that specific transaction.
          </div>
          <div className="contentBold">
            {" "}
            We reserve the right to deduct reputation points and/or remove your
            username if you violate these Terms, applicable law or engage in
            harmful behaviour.
          </div>
          <div className="flex gap-1">
            <div className="subHeadingSpan text-text-primary">3.3 </div>
            <div className="contentBold">Other Products:</div>
          </div>{" "}
          <div className="content">
            {" "}
            We may from time to time, in the future, offer additional products,
            and such additional products shall be considered a Product as used
            herein regardless of whether such product is defined in the Terms.
          </div>
          <div className="subHeading text-text-primary">4. Sharing</div>
          <div className="content">
            {" "}
            We do not collect or share any personal information, except for
            wallet addresses and telegram usernames of liquidity providers. Your
            telegram username and profile information including reputation
            points and on-chain transactions are publicly available data. We
            have visibility over other aspects of the transactions between the
            users which occur off-chain.
          </div>
          <div className="content">
            {" "}
            We reserve the right to revoke access to your account and deduct
            reputation points at our sole discretion, based on your on-chain
            activity and transaction history thereby limiting your ability to
            interact with the Protocol. Further, access to your account may be
            restricted in order to comply with legal requirements as per court
            orders.
          </div>
          <div className="subHeading text-text-primary">
            5. Intellectual Property
          </div>
          <div className="content">
            We own all the Intellectual Property rights related to our Product,
            including their functionality, design, software, appearance and the
            compilation of all information, images and content contained
            therein. This ownership encompasses all copyrights, trademarks,
            service marks, trade secrets and other proprietary rights under
            applicable law.
          </div>
          <div className="contentBold">
            You agree not to copy, download, or print any content without our
            explicit written content.
          </div>
          <div className="subHeading text-text-primary">6. Acceptable Use</div>
          <div className="contentBold">
            {" "}
            You may use our Product subject to these Terms. You agree to not
            engage in or attempt in any of the following categories of
            activities in relation to your access and use of our Product:
          </div>
          <div className="content">
            Intellectual Property Infringement: any activity that infringes upon
            any of our Intellectual Property as per Clause 5 of these Terms.
          </div>
          <div className="content">
            Fraud and Misrepresentations: Commit any fraudulent acts or making
            statements or representations regarding your identity, transactions,
            or any other aspects related to your use of our Product.
          </div>
          <div className="content">
            Unauthorised access: attempt to gain authorised access to any part
            of the Product, the systems or networks connected to the Product, or
            any services owned or operated by us.
          </div>
          <div className="content">
            Disruption of Services: interfere with or disrupt the functionality
            of the Product, including but not limited to transmitting any
            harmful code, such as viruses, malware, denial of service attacks,
            ransomware or other malicious code. You will also not use, modify,
            distribute, tamper with, reverse engineer, disassemble or recompile
            any of our Product for any purpose other than as expressly permitted
            under these Terms and will not introduce any computer virus, worm,
            time bomb, trojan horse, cancelbot, logic bomb or any other form of
            programming designed to damage, destroy or otherwise impair the
            Products functionality or operation for any user or liquidity
            provider.
          </div>
          <div className="content">
            Illegal Activity: engage in any activity that is illegal, such as
            soliciting information from anyone under the age of 18 or any
            activity that is otherwise harmful, threatening, abusive, harassing,
            tortious, vulgar, pornographic, libelous invasive of others privacy,
            hateful, discriminatory or otherwise objectionable.
          </div>
          <div className="content">
            Sale of Stolen Property: buy or sell or transfer any stolen items,
            fraudulently obtained or any unlawful gain.
          </div>
          <div className="content">
            Data Mining: extract, aggregate or manipulate data from our Product
            for commercial purposes without our prior written consent.
          </div>
          <div className="content">
            Violate any law: engage in any activities that violate applicable
            laws or regulations, including those pertaining to financial
            transactions, data privacy, money laundering and other illicit
            activities.
          </div>
          <div className="subHeading text-text-primary">7. No Warranty</div>
          <div className="content">
            {" "}
            The Product is provided on an "as-available" and "as-is" basis,
            without any warranties of any kind. Your access to and use of our
            Product is permitted solely at our discretion. We make no
            warranties, whether express, implied or statutory including, but not
            limited to the warranties of merchantability and fitness for a
            particular purpose.
          </div>
          <div className="content">
            {" "}
            We do not represent or warrant that any features or functionalities
            of our Product will be available, uninterrupted, or error-free, that
            any defects will be corrected, or that the Product will be free from
            hacking, ransomware, denial-of-service attacks, viruses, or other
            malicious code. You accept all risks associated with using our
            Product.
          </div>
          <div className="content">
            {" "}
            We do not endorse, guarantee, or assume responsibility for any
            advertisements, offers, or statement made by third-parties
            concerning any of our Product.
          </div>
          <div className="content">
            {" "}
            Similarly, the Protocol is accessed by us on an “as available” and
            “as is” basis. We do not own, or control the Protocol, which is run
            autonomously with the help of self-executing smart contracts on the
            blockchain and therefore no liability related to the functioning of
            the Protocol is attributable to us. This includes any direct,
            indirect, incidental, or consequential damages related to your use
            of the Protocol.
          </div>
          <div className="content">
            {" "}
            Any payments of financial transactions that you engage in will be
            processed at either the Protocol level with the help of automated
            smart contracts or directly between users in a peer to peer manner.
            Once the orders for transactions are placed, we have no control over
            these payments or transactions, nor do we have the ability to
            reverse any such transactions.
          </div>
          <div className="subHeading text-text-primary">
            8. Compliances and Tax Obligations
          </div>
          <div className="content">
            The Product may not be available for use in your jurisdiction. By
            accessing or using any of our Product, you agree that you are solely
            responsible for ensuring compliance with all applicable laws and
            regulations in your jurisdiction.
          </div>
          <div className="content">
            In particular, your use of our Product or the Protocol may have tax
            implications, including but not limited to income tax, goods and
            services tax, capital gains tax, sales tax, income tax and any other
            applicable taxes depending on your applicable jurisdiction. It is
            your sole responsibility to determine if taxes apply to any
            transactions, you initiate or receive, and to report, file, or remit
            the appropriate amounts to the relevant authorities.
          </div>
          <div className="content">
            You acknowledge that we are not responsible for reporting,
            monitoring, or tracking your transactions. It is your sole
            responsibility to manage and fulfil any reporting or compliance
            obligations related to your transactions. Furthermore, you
            acknowledge that these transactions are facilitated by the Protocol,
            and we merely provide an interface to access the Protocol.
          </div>
          <div className="content">
            As a liquidity provider, you may need to meet additional compliance
            requirements when engaging in direct fiat transactions with other
            users. Specifically, you are responsible for fulfilling any
            Anti-Money Laundering (AML) obligations relevant to your
            jurisdiction. You acknowledge that you have been adequately informed
            of these responsibilities and that we are not liable for managing
            them on your behalf. Additionally, you understand that these
            transactions occur directly between users, and we do not have
            visibility over these transactions nor any responsibility associate
            with them. We are not liable for any legal action against any
            liquidity provider.
          </div>
          <div className="subHeading text-text-primary">
            9. Errors, Inaccuracies, and Omissions
          </div>{" "}
          <div className="content">
            {" "}
            The Product may contain errors, inaccuracies, or omissions,
            particularly in Product descriptions, availability, credentials or
            usage. We reserve the right but are not obligated, to correct any
            such issues or update information at any time.
          </div>
          <div className="content">
            {" "}
            By using our Product, you acknowledge that we cannot update, amend,
            delete, or restrict access to information users store on
            decentralised networks. While we have no obligation to modify or
            limit access to such information, we may do so at our discretion or
            when required by law.
          </div>
          <div className="subHeading text-text-primary">
            10. Disclaimers and General Assumption of Risk
          </div>
          <div className="content">
            {" "}
            By accessing and using the Product, you represent that you are
            financially and technically sound enough to understand the inherent
            risks associated with using blockchain-based systems and products,
            and that you have a working knowledge of the usage and intricacies
            of digital assets.
          </div>
          <div className="content">
            {" "}
            You understand that smart contract transactions automatically
            execute and settle transactions and these transactions are
            irreversible in nature. Our Product relies on emerging technologies,
            such as Ethereum and Base. Some offerings are subject to increased
            risk through your potential misuse of public/private key
            cryptography, or failing to properly update or run software to
            accommodate protocol upgrades. By using the Product, you explicitly
            acknowledge and accept these heightened risks. You further
            understand that protocols present their own risks of use, and that
            supporting or participating in the protocol may result in losses if
            your participation violates the specific rules of that protocol.
          </div>
          <div className="content">
            {" "}
            You acknowledge that selling your crypto may put you at risk of
            having your bank accounts frozen. Additionally, if you are a
            liquidity provider to the Protocol via the Product, withdrawing your
            crypto or undertaking transactions may also result in your bank
            accounts being frozen or restricted. Additionally, you understand
            that as a liquidity provider, you have specific obligations under
            the applicable law. You acknowledge that it is your sole
            responsibility to comply with anti-money laundering regulations and
            tax laws applicable in your jurisdiction. You accept full
            responsibility for adhering to all relevant laws and legal
            requirements related to fiat and crypto swaps, particularly
            concerning anti-money laundering and tax regulations and requisite
            government reporting and release us of any such responsibility and
            agree to indemnify us against any claims related to your failure to
            adhere to any such responsibility or breach any applicable law.
          </div>
          <div className="subHeading text-text-primary">
            11. Limitation of Liability
          </div>
          <div className="content">
            {" "}
            Your expressly agree to assume all the risks associated with
            accessing and using our Product. By doing so, you agree that we are
            not liable for any lost profits, revenues, goodwill, direct,
            indirect, punitive, incidental, special, cover, business
            interruption, punitive or consequential damages arising from your
            use or inability to use our Product. This applies regardless of
            whether the claim is based on contract, tort, or any other legal
            theory, even if we were advised or had the knowledge of the
            possibility of such damages.
          </div>
          <div className="content">
            {" "}
            You understand that we cannot and do not guarantee or warrant that
            files available for downloading from the internet or the Services
            will be free of viruses or other destructive code. You are
            responsible for implementing sufficient procedures and checkpoints
            to satisfy your particular requirements for anti-virus protection
            and accuracy of data input and output, and for maintaining a means
            external to our Services for any reconstruction of any lost data. TO
            THE FULLEST EXTENT PROVIDED BY LAW, WE WILL NOT BE LIABLE FOR ANY
            LOSS OR DAMAGE CAUSED BY A DISTRIBUTED DENIAL-OF-SERVICE ATTACK,
            CONDUCT OF THIRD PARTIES OR USERS, INCLUDING THREAT ACTORS, VIRUSES,
            OR OTHER TECHNOLOGICALLY HARMFUL MATERIAL THAT MAY INFECT YOUR
            COMPUTER EQUIPMENT, COMPUTER PROGRAMS, DATA, OR OTHER PROPRIETARY
            MATERIAL DUE TO YOUR USE OF THE SERVICES OR ANY SERVICES OR ITEMS
            OBTAINED THROUGH THE SERVICES OR TO YOUR DOWNLOADING OF ANY MATERIAL
            POSTED ON THEM, OR ON ANY WEBSITE LINKED TO THEM.
          </div>
          <div className="content">
            {" "}
            YOUR USE OF THE SERVICES, THEIR CONTENT, AND ANY SERVICES OR ITEMS
            OBTAINED THROUGH THE SERVICES IS AT YOUR OWN RISK. THE SERVICES,
            THEIR CONTENT, AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE
            SERVICES ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS,
            WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED.
            NEITHER COMPANY NOR ANY PERSON ASSOCIATED WITH COMPANY MAKES ANY
            WARRANTY OR REPRESENTATION WITH RESPECT TO THE COMPLETENESS,
            SECURITY, RELIABILITY, QUALITY, ACCURACY, OR AVAILABILITY OF THE
            SERVICES. WITHOUT LIMITING THE FOREGOING, NEITHER COMPANY NOR ANYONE
            ASSOCIATED WITH COMPANY REPRESENTS OR WARRANTS THAT THE SERVICES,
            THEIR CONTENT, OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE
            SERVICES WILL BE ACCURATE, RELIABLE, ERROR-FREE, OR UNINTERRUPTED,
            THAT DEFECTS WILL BE CORRECTED, THAT OUR SERVICES OR THE SERVER THAT
            MAKES THEM AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL
            COMPONENTS, OR THAT THE SERVICES OR ANY SERVICES OR ITEMS OBTAINED
            THROUGH THE SERVICES WILL OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS.
          </div>
          <div className="content">
            {" "}
            WE HAVE NO RESPONSIBILITY OR LIABILITY FOR ANY LOSSES THAT YOU MAY
            INCUR AS A RESULT OF SWAPS, TRADES, OR OTHER TRANSACTIONS THAT YOU
            MAY ENGAGE IN CONNECTION WITH THE SERVICES FOR ANY REASON
            WHATSOEVER, INCLUDING WITHOUT LIMITATION LOSSES ARISING FROM
            SOFTWARE DEFECTS, MALFUNCTIONS, OR A LACK OF ACCESS TO THE SERVICES.
          </div>
          <div className="content">
            {" "}
            TO THE FULLEST EXTENT PROVIDED BY LAW, COMPANY HEREBY DISCLAIMS ALL
            WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY, OR
            OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF
            MERCHANTABILITY, NON-INFRINGEMENT, AND FITNESS FOR PARTICULAR
            PURPOSE.
          </div>
          <div className="content">
            {" "}
            YOU ACKNOWLEDGE THAT YOUR DATA AND ASSETS ON THE SERVICES MAY BECOME
            IRRETRIEVABLY LOST OR CORRUPTED OR TEMPORARILY UNAVAILABLE DUE TO A
            VARIETY OF CAUSES, AND YOU AGREE THAT, TO THE MAXIMUM EXTENT
            PERMITTED UNDER APPLICABLE LAW, WE WILL NOT BE LIABLE FOR ANY LOSS
            OR DAMAGE CAUSED BY DENIAL-OF-SERVICE ATTACKS, SOFTWARE FAILURES,
            VIRUSES OR OTHER TECHNOLOGICALLY HARMFUL MATERIALS (INCLUDING THOSE
            WHICH MAY INFECT YOUR COMPUTER EQUIPMENT OR DEVICES), PROTOCOL
            CHANGES BY THIRD-PARTY PROVIDERS, INTERNET OUTAGES, FORCE MAJEURE
            EVENTS OR OTHER DISASTERS, SCHEDULED OR UNSCHEDULED MAINTENANCE, OR
            OTHER CAUSES EITHER WITHIN OR OUTSIDE OF OUR CONTROL.
          </div>
          <div className="content">
            {" "}
            YOU FURTHER ACKNOWLEDGE AND AGREE THAT COMPANY HAS NO LIABILITY FOR
            LOSS OR THEFT OF YOUR WALLET KEYS OR ANY OTHER KEYS USED TO ACCESS
            OTHER DIGITAL WALLETS YOU MIGHT USE.
          </div>
          <div className="content">
            {" "}
            TO THE FULLEST EXTENT PROVIDED BY LAW, IN NO EVENT WILL COMPANY, ITS
            AFFILIATES, OR THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES,
            AGENTS, OFFICERS, OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND,
            UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN CONNECTION WITH YOUR
            USE, OR INABILITY TO USE, THE SERVICES, ANY WEBSITES LINKED TO IT,
            ANY CONTENT ON THE SERVICES OR SUCH OTHER WEBSITES, INCLUDING ANY
            DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE
            DAMAGES, INCLUDING BUT NOT LIMITED TO, PERSONAL INJURY, PAIN AND
            SUFFERING, EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS OF PROFITS,
            LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS OF USE, LOSS OF
            GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY TORT (INCLUDING
            NEGLIGENCE), BREACH OF CONTRACT, OR OTHERWISE, EVEN IF FORESEEABLE.
          </div>
          <div className="content">
            {" "}
            WE HAVE NO CONTROL OVER, TAKE NO RESPONSIBILITY FOR, AND SHALL NOT
            BE LIABLE FOR THE CONDUCT OF THIRD PARTIES, INCLUDING THREAT ACTORS.
          </div>
          <div className="content">
            {" "}
            THE FOREGOING DOES NOT AFFECT ANY LIABILITY THAT CANNOT BE EXCLUDED
            OR LIMITED UNDER APPLICABLE LAW.
          </div>
          <div className="subHeading text-text-primary">
            12. Indemnification
          </div>
          <div className="content">
            {" "}
            By assessing or using our Product, you agree to indemnify, defend,
            and hold harmless P2P.me, our affiliates, officers, directors,
            employees, agents, licensors and suppliers from and against all
            losses, expenses, damages and costs, including reasonable attorneys’
            fees, arising or relating to (a) any violation of the applicable
            law; (b) these Terms; (c) any other third party use or access of our
            Product (d) your access or use of any of our Product; (e) any
            dispute between you and any other user of our Product or any of your
            customers or users.
          </div>
          <div className="subHeading text-text-primary">
            13. Governing Law; Dispute Resolution
          </div>
          <div className="content">
            {" "}
            These Terms and any separate agreements whereby we provide you
            services, and any dispute or claim arising therefrom or related
            thereto (in each case, including non-contractual disputes, tortious
            claims or claims) shall be governed by and construed in accordance
            with the laws of the Republic of Panama, without regard to
            principles of conflict of laws (whether of this or any other
            jurisdiction).
          </div>
          <div className="content">
            {" "}
            In the event of any dispute, we will use our best efforts to resolve
            any potential disputes through informal, good-faith negotiations. If
            any potential dispute arises, you must contact us by sending us an
            email, so that we can attempt to resolve it without resorting to
            formal dispute resolutions. If we are not able to reach an
            information resolution within 90 days of your email, then you and we
            both agree to resolve such potential disputes according to the
            following process set forth below:
          </div>
          <div className="content">
            {" "}
            Any controversy or dispute which arise out or is related to this
            contract, and the interpretation, application, performance and
            termination thereof, must be decided by Arbitration, following an
            attempt at Conciliation, administered by the Panama Conciliation and
            Arbitration Centre (CECAP) in accordance with its procedural rules.
            The number of arbitrators shall be [one]. The seat, or legal place,
            of arbitration shall be Panama City. The language to be used in the
            arbitral proceedings shall be [English]. The governing law of the
            contract shall be the substantive law of the Republic of Panama. The
            arbitral award shall be final for the Parties.
          </div>
          <div className="subHeading text-text-primary">14. Severability</div>
          <div className="content">
            {" "}
            If any provision of these Terms shall be determined to be invalid or
            unenforceable under any rule, law or regulation of any jurisdiction,
            such provisions will be changed and interpreted to accomplish the
            objectives of the provisions to the greatest extent possible under
            any applicable law and the validity or enforceability of any other
            provision of these Terms shall not be affected.
          </div>
          <div className="subHeading text-text-primary">15. Not regulated</div>
          <div className="content">
            {" "}
            We are not registered with any regulatory body in any capacity. You
            understand and acknowledge that we do not broker trading orders on
            your behalf. We do not facilitate, execute, or settle your
            transactions, all transactions are carried out directly between
            users on public distributed blockchains such as Ethereum and Base.
            Accordingly, we do not and cannot guarantee the best market pricing
            or execution through our Product. Any reference to pricing is merely
            indicative in nature and need not be an accurate representation of
            pricing available on the Protocol itself or elsewhere.
          </div>
          <div className="subHeading text-text-primary">
            16. Changes to Terms
          </div>
          <div className="content">
            {" "}
            We reserve the right to amend or update these Terms at any time.
            Your continued use of the Product after an change shall constitute
            consent.
          </div>
          <div className="subHeading text-text-primary">
            17. Information About You and Your Visits to the Services
          </div>
          <div className="content">
            {" "}
            All information we collect on the Services is subject to our Privacy
            Policy. By using the Services, you consent to all actions taken by
            us with respect to your information in compliance with the Privacy
            Policy. Also note that, if you log into our Services using your
            social media accounts provided by third parties, all information you
            provide on the Services will be mirrored and available on those
            social media accounts as well. You specifically consent to this
            practice. All information on the social media channels you connect
            will be collected by the third party operators of those services,
            and subject to their privacy policies, so we encourage you to review
            those policies and understand them well, before connecting through
            your social media accounts.
          </div>
          <div className="subHeading text-text-primary">
            18. Entire Agreement
          </div>
          <div className="content">
            {" "}
            The Terms of Use and, our Privacy Policy constitute the sole and
            entire agreement between you and Company regarding the Services and
            supersede all prior and contemporaneous understandings, agreements,
            representations, and warranties, both written and oral, regarding
            the Services.
          </div>
          <div className="subHeading text-text-primary">
            19. Your Comments and Concerns
          </div>
          <div className="content">
            {" "}
            All other Feedback, comments, requests for technical support, and
            other communications relating to the Services should be directed to:
            compliance@p2p.me
          </div>
        </div>
        <DialogFooter>
          {showAccept && (
            <Button
              label="Accept"
              onClick={handlePrivacyPolicyAccepted}
              size={ButtonSize.small}
              widthFull
            />
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default PrivacyPolicy;
